export const styles = theme => ({
  bodyBoxMoblie: {
    maxWidth: '100%',
    fontFamily: theme.typography.fontFamily,
    // border: '1px solid #ccc',
    padding: theme.spacing(1, 1),
    // height: '65px',
  },
  bodyBox: {
    maxWidth: '100%',
    fontFamily: theme.typography.fontFamily,
    border: '1px solid #ccc',
    padding: theme.spacing(1, 1),
    '&:nth-of-type(even)': {
      borderRight: 'none',
      borderLeft: 'none',
    },
    height: '65px',
    textAlign: 'center',
  },
  value: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '24px',
    color: theme.palette.primary.main,
    padding: theme.spacing(0, 1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '34px',
    },
  },
  textTemp: {
    position: 'absolute',
    marginTop: 5,
    fontSize: 10,
  },
  titleSub: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '11px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
  titleWeek: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
  },
  valueAll: {
    fontWeight: 600,
    fontSize: '20px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.primary.main,
  },
  valuePer: {
    fontWeight: 500,
    fontSize: '16px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.primary.main,
  },
});
